import ShippingMethodsUserForm from './CustomForms/ShippingMethods';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withFormik } from 'formik';

import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import renderComponent from 'recompose/renderComponent';

import qs from 'qs';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { submitShippingMethods } from 'src/common/facades/eagle/checkout';
import { getCookies } from 'src/client/js/facades/eagle/helpers/cookies';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import { getCart, isShippingMethodsLoading, getOrderDetails } from '../../../store/selectors/cart';
import { getShippingMethods, updateShippingMethods } from '../../../store/thunks/cart';
import {
  trackCheckoutSubmitButton,
  trackGeneralClick,
  trackErrors,
  trackSelectedShippingMethod,
} from '../../../analytics/category/checkout';
import { filterShippingMethods } from './helpers';
import logger from 'src/logger';
import withErrorTranslations from '../../hocs/withErrorTranslations';
import withCountry from '../../hocs/withCountry';

const withShippingMethods = compose(
  withErrorTranslations,
  withCountry,
  connect(
    state => ({
      orderDetails: getOrderDetails(state),
      shippingMethods: get(getCart(state), 'shippingMethods.items', []),
      isDataLoading: isShippingMethodsLoading(state),
    }),
    (dispatch, { country: countryModel, sendErrorMessage }) => ({
      getShippingMethods: () => (dispatch(getShippingMethods({
        countryModel,
        sendErrorMessage,
      }))),
    })
  ),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      props.getShippingMethods();
    },
  }),
  withRouter,
  withProps(props => {
    if (!isEmpty(props.shippingMethods)) {
      let formFields = (get(props, 'form.body') || []).slice();
      formFields = formFields.map(field => {
        if (field.primary.name === 'selectedShippingRateId') {
          return filterShippingMethods(field, props.shippingMethods, props.country);
        }
        return field;
      });
      return {
        form: {
          ...props.form,
          body: formFields,
        },
        shipmentNumber: get(props, 'orderDetails.shipment.number') || null,
      };
    }
  }),
  connect(
    null,
    (dispatch, { shipmentNumber, country }) => ({
      updateShippingMethods: (selectedShippingRateId, errorMessage) =>
        dispatch(updateShippingMethods(shipmentNumber, selectedShippingRateId, country.currency, errorMessage))
    })
  ),
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: props => {
      const formFields = get(props, 'form.body') || [];
      const shippingMethodsField = formFields.find(field => field.primary.name === 'selectedShippingRateId');
      const shippingMethods = shippingMethodsField.items || [];

      const selectedShippingRate = shippingMethods.find(option => option.isPreSelected) || {};
      const selectedShippingRateId = get(selectedShippingRate, 'id', null);

      return { selectedShippingRateId };
    },
    handleSubmit: (values, formikBag) => {
      trackCheckoutSubmitButton('Shipping Methods', event.type);
      const props = formikBag.props;
      const selectedShippingRateId = parseInt(values.selectedShippingRateId, 10);  // for some reason Formik transforms the id into string on Change
      const payload = {
        ...values,
        selectedShippingRateId,
        shipmentNumber: props.shipmentNumber
      };
      submitShippingMethods(payload, getCookies())
        .then(() => {
          const returnUrl = qs.parse(props.history.location.search, { ignoreQueryPrefix: true }).return_to;
          if (props.history.location.search.includes('return_to')) {
            return window.location = returnUrl;
          }
          window.location = localiseUrl(props.country, '/checkout-v2');
        })
        .catch(error => {
          trackErrors(`Shipping Methods - ${get(error, 'details[0].message', error.description)}`);
          logger.error('Error when submitting shipping methods form', error);
        });
    }
  }),
  withHandlers({
    handleClick: (props) => () => {
      const page = props.history.location.pathname;
      trackGeneralClick('Back to link', page);
    },
    handleChange: (props) => (event) => {
      const translatedError = get('props.model.prismicGlobalContentModel.error.checkout.shippingMethods', null);
      props.updateShippingMethods(event.target.value, translatedError);
      const value = event.target.attributes['data-option'].value;
      props.handleChange(event);
      trackSelectedShippingMethod(event.target.id, value);
    },
  }),
  renderComponent(ShippingMethodsUserForm),
);

export default withShippingMethods;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/withShippingMethods.js